module.exports = __webpack_public_path__ + "static/images/survey/trash.png";